function ButtonATCDisabled({ text, outlined, onHandle }) {
  return (
    <button type="button" className={`button-atc-disabled relative w-full uppercase button-primary button-large border-solid ${outlined ? 'button-outlined' : ''}`} onClick={onHandle}>
      {text}
    </button>
  )
}

export default ButtonATCDisabled
